import axiosPost from '../axiosPost';

export const conciliacionesRevisar = async (arg) => {
    const { operaciones, comentario } = arg

    const body = {
        "service": "BindConciliacionRevisar",
        "params": {
            "bindConciliacionOperaciones": operaciones,
            "bindConciliacionObservacion": comentario
        }
    };

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } 
    catch (err) {
        console.log(err)
    };
};